/**
 * Scope a reason dropdown to the reasons mapped onto the picked call
 * sub-status (ADR-0067). Used for BOTH the follow-up reason and the lost
 * reason dropdowns so the two behave identically.
 *
 * The EMPTY mapping is meaningful: it means "unrestricted", so we return
 * every active reason. That is the pre-mapping behaviour, which is what
 * keeps sub-statuses nobody has mapped yet working exactly as before.
 *
 * We intersect against the active list rather than reading names straight
 * off the mapping, so a reason that was deactivated or soft-deleted after
 * being mapped disappears from the dropdown instead of lingering.
 *
 * Shared by the complete-follow-up dialog and the lead detail log form so
 * the surfaces can never drift apart.
 */
export function scopeReasons<T extends { id: string }>(
  activeReasons: ReadonlyArray<T>,
  mapped: ReadonlyArray<{ id: string }> | null | undefined,
): T[] {
  const list = [...activeReasons];
  if (!mapped || mapped.length === 0) return list;
  const allowed = new Set(mapped.map((r) => r.id));
  return list.filter((r) => allowed.has(r.id));
}
